(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inp-hero"] && !Shopify.designMode) return;
  try {
    
  // Offer countdown: "2026-11-30 23:59" is read as Bulgarian time; hidden once the offer has ended
  if (!customElements.get('inp-countdown')) {
    customElements.define(
      'inp-countdown',
      class extends HTMLElement {
        connectedCallback() {
          const [date, time = '23:59'] = this.dataset.end.trim().split(/\s+/);
          this.end = this.bulgarianTime(date, time);
          this.out = this.querySelector('.inp-countdown__time');
          if (Number.isNaN(this.end)) return;
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        bulgarianTime(date, time) {
          const guess = Date.parse(`${date}T${time}:00Z`);
          if (Number.isNaN(guess)) return NaN;
          const sofia = new Date(new Date(guess).toLocaleString('en-US', { timeZone: 'Europe/Sofia' }));
          const utc = new Date(new Date(guess).toLocaleString('en-US', { timeZone: 'UTC' }));
          return guess - (sofia - utc);
        }

        tick() {
          const left = this.end - Date.now();
          if (left <= 0) {
            this.hidden = true;
            clearInterval(this.timer);
            return;
          }
          const s = Math.floor(left / 1000);
          const days = Math.floor(s / 86400);
          const pad = (n) => String(n).padStart(2, '0');
          const clock = `${pad(Math.floor((s % 86400) / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
          this.out.textContent = days > 0 ? `${days}d ${clock}` : clock;
          this.hidden = false;
        }
      }
    );
  }

  // Blade colour swatches: swap the photo, recolour the glow and replay the jump in that colour
  if (!customElements.get('inp-hero-colours')) {
    customElements.define(
      'inp-hero-colours',
      class extends HTMLElement {
        connectedCallback() {
          this.section = this.closest('.inp-hero');
          this.shots = [...this.section.querySelectorAll('.inp-hero__shot')];
          this.swatches = [...this.querySelectorAll('.inp-hero__swatch')];
          this.name = this.querySelector('.inp-hero__colour-name');
          this.addEventListener('click', (event) => {
            const swatch = event.target.closest('.inp-hero__swatch');
            if (swatch) this.select(swatch);
          });
          this.addEventListener('keydown', (event) => {
            const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
            if (!step) return;
            event.preventDefault();
            const current = this.swatches.findIndex((s) => s.getAttribute('aria-checked') === 'true');
            const next = this.swatches[(current + step + this.swatches.length) % this.swatches.length];
            next.focus();
            this.select(next);
          });
          this.swatches.forEach((s, i) => (s.tabIndex = i === 0 ? 0 : -1));
        }

        select(swatch) {
          const index = Number(swatch.dataset.index);
          this.swatches.forEach((s) => {
            const on = s === swatch;
            s.setAttribute('aria-checked', String(on));
            s.tabIndex = on ? 0 : -1;
          });
          this.shots.forEach((shot, i) => (shot.dataset.active = String(i === index)));
          this.name.textContent = swatch.querySelector('.visually-hidden').textContent;
          // Restart the one-shot animations: wave on the swatch, flare on the saber, name slide-in
          const replay = (el, cls) => {
            if (!el) return;
            el.classList.remove(cls);
            void el.offsetWidth;
            el.classList.add(cls);
          };
          replay(swatch, 'is-burst');
          replay(this.section.querySelector('.inp-hero__saber'), 'is-igniting');
          replay(this.name, 'is-new');
          const hex = swatch.dataset.glow.replace('#', '');
          const rgb = [0, 2, 4].map((i) => parseInt(hex.slice(i, i + 2), 16)).join(',');
          this.section.style.setProperty('--inp-glow', swatch.dataset.glow);
          this.section.style.setProperty('--inp-glow-rgb', rgb);
          this.section.querySelector('inp-warp')?.jump(rgb);
        }
      }
    );
  }

  // Close-ups: a click on a point opens the x-ray panel from that point; Esc, the close button
  // or a click outside closes it and gives focus back to the point
  if (!customElements.get('inp-xray')) {
    customElements.define(
      'inp-xray',
      class extends HTMLElement {
        connectedCallback() {
          this.panel = this.querySelector('.inp-xray');
          if (!this.panel) return;
          this.items = [...this.panel.querySelectorAll('.inp-xray__item')];
          this.onKey = (event) => event.key === 'Escape' && this.close();
          this.onOutside = (event) => {
            if (!this.panel.contains(event.target) && !event.target.closest('.inp-callout__hit')) this.close();
          };
          this.addEventListener('click', (event) => {
            const hit = event.target.closest('.inp-callout__hit');
            if (hit) {
              event.stopPropagation();
              hit === this.trigger && this.isOpen ? this.close() : this.open(hit);
            }
          });
          this.panel.querySelector('.inp-xray__close').addEventListener('click', () => this.close());
        }

        disconnectedCallback() {
          document.removeEventListener('keydown', this.onKey);
          document.removeEventListener('click', this.onOutside);
        }

        open(hit) {
          if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
          this.trigger = hit;
          this.items.forEach((item) => (item.hidden = item.dataset.detail !== hit.dataset.detail));
          this.panel.classList.remove('is-open');
          this.panel.hidden = false;
          // The circle starts at the clicked point, measured inside the panel
          const from = hit.getBoundingClientRect();
          const box = this.panel.getBoundingClientRect();
          this.panel.style.setProperty('--ox', `${from.left + from.width / 2 - box.left}px`);
          this.panel.style.setProperty('--oy', `${from.top + from.height / 2 - box.top}px`);
          void this.panel.offsetWidth;
          this.panel.classList.add('is-open');
          this.classList.add('is-xray');
          hit.setAttribute('aria-expanded', 'true');
          this.isOpen = true;
          this.panel.querySelector('.inp-xray__close').focus({ preventScroll: true });
          document.addEventListener('keydown', this.onKey);
          document.addEventListener('click', this.onOutside);
        }

        close() {
          if (!this.isOpen) return;
          this.isOpen = false;
          this.panel.classList.remove('is-open');
          this.classList.remove('is-xray');
          document.removeEventListener('keydown', this.onKey);
          document.removeEventListener('click', this.onOutside);
          const hit = this.trigger;
          hit?.setAttribute('aria-expanded', 'false');
          hit?.focus({ preventScroll: true });
          const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          setTimeout(() => {
            if (!this.isOpen) this.panel.hidden = true;
          }, still ? 0 : 600);
        }
      }
    );
  }

  // Star field behind the hero: stars rush out from the saber in a light-speed jump, then drift
  if (!customElements.get('inp-warp')) {
    customElements.define(
      'inp-warp',
      class extends HTMLElement {
        connectedCallback() {
          this.canvas = this.querySelector('canvas');
          this.ctx = this.canvas.getContext('2d');
          this.still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.colors = ['255,255,255', '255,255,255', '77,242,255', '161,0,255'];
          this.resize = this.resize.bind(this);
          this.frame = this.frame.bind(this);
          this.resizeObserver = new ResizeObserver(this.resize);
          this.resizeObserver.observe(this);
          this.visible = true;
          this.intersection = new IntersectionObserver(([entry]) => {
            this.visible = entry.isIntersecting;
            if (this.visible && !this.still) this.play();
          });
          this.intersection.observe(this);
          this.resize();
          this.start = performance.now();
          this.still ? this.draw(0) : this.play();
        }

        disconnectedCallback() {
          this.resizeObserver.disconnect();
          this.intersection.disconnect();
          cancelAnimationFrame(this.raf);
        }

        resize() {
          const ratio = Math.min(window.devicePixelRatio || 1, 2);
          this.w = this.clientWidth;
          this.h = this.clientHeight;
          this.canvas.width = this.w * ratio;
          this.canvas.height = this.h * ratio;
          this.ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
          // The jump starts from the saber photo, wherever the layout puts it
          const box = this.getBoundingClientRect();
          const saber = this.closest('.inp-hero')?.querySelector('.inp-hero__shots, .inp-hero__media')?.getBoundingClientRect();
          this.cx = saber ? saber.left - box.left + saber.width / 2 : this.w * 0.5;
          this.cy = saber ? saber.top - box.top + saber.height / 2 : this.h * 0.5;
          const count = Math.round(Math.min(480, (this.w * this.h) / 2600));
          this.stars = Array.from({ length: count }, () => this.star(Math.random()));
          if (this.still) this.draw(0);
        }

        star(z) {
          return {
            angle: Math.random() * Math.PI * 2,
            z,
            size: Math.random() * 1.2 + 0.4,
            color: this.colors[Math.floor(Math.random() * this.colors.length)],
          };
        }

        // A new blade colour: tint the cyan stars with it and run the jump again
        jump(rgb) {
          this.colors = ['255,255,255', '255,255,255', rgb, rgb, '161,0,255'];
          this.stars.forEach((s) => {
            if (s.color !== '255,255,255') s.color = this.colors[2 + Math.floor(Math.random() * 3)];
          });
          if (this.still) return this.draw(0);
          this.start = performance.now();
          this.play();
        }

        play() {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(this.frame);
        }

        frame(now) {
          if (!this.visible) return;
          const t = (now - this.start) / 1000;
          // 0 → 1 → 0 over the first 2.4 s: the jump, then calm drift
          const jump = t < 2.4 ? Math.sin((t / 2.4) * Math.PI) ** 2 : 0;
          this.draw(jump);
          this.raf = requestAnimationFrame(this.frame);
        }

        draw(jump) {
          const { ctx, w, h, cx, cy } = this;
          const reach = Math.hypot(Math.max(cx, w - cx), Math.max(cy, h - cy));
          ctx.clearRect(0, 0, w, h);
          const speed = 0.0009 + jump * 0.022;
          for (const s of this.stars) {
            if (!this.still) s.z += speed * (0.3 + s.z);
            if (s.z > 1) Object.assign(s, this.star(0.02));
            const r = s.z * s.z * reach;
            const x = cx + Math.cos(s.angle) * r;
            const y = cy + Math.sin(s.angle) * r;
            // During the jump the trails reach almost half the section, so they show past the photo
            const trail = jump * reach * 0.45 * s.z;
            const alpha = Math.min(1, s.z * 2.2) * (0.55 + 0.45 * jump);
            ctx.strokeStyle = `rgba(${s.color},${alpha})`;
            ctx.lineWidth = s.size * (0.6 + s.z) * (1 + jump * 0.6);
            ctx.lineCap = 'round';
            ctx.beginPath();
            ctx.moveTo(x - Math.cos(s.angle) * trail, y - Math.sin(s.angle) * trail);
            ctx.lineTo(x + 0.01, y + 0.01);
            ctx.stroke();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inp-journey"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('inp-journey')) {
    customElements.define(
      'inp-journey',
      class extends HTMLElement {
        connectedCallback() {
          if (!('IntersectionObserver' in window)) {
            this.classList.add('is-lit');
            return;
          }
          this.observer = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) {
                this.classList.add('is-lit');
                this.observer.disconnect();
              }
            },
            { threshold: 0.35 }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inp-tutorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('inp-tutorial')) {
    customElements.define(
      'inp-tutorial',
      class InpTutorial extends HTMLElement {
        connectedCallback() {
          this.media = this.querySelector('.inp-tutorial__frame');
          this.video = this.querySelector('.inp-tutorial__video');
          if (!this.video) return;

          this.playButton = this.querySelector('.inp-tutorial__play');
          this.scrub = this.querySelector('.inp-tutorial__scrub');
          this.time = this.querySelector('.inp-tutorial__time');
          this.now = this.querySelector('.inp-tutorial__now');
          this.chapters = [...this.querySelectorAll('.inp-tutorial__chapter')]
            .map((button) => ({ button, at: this.parseTime(button.dataset.time) }))
            .filter((chapter) => chapter.at !== null)
            .sort((a, b) => a.at - b.at);

          this.playButton.addEventListener('click', () => (this.video.paused ? this.play() : this.video.pause()));
          this.video.addEventListener('play', () => this.playButton.setAttribute('aria-pressed', 'true'));
          this.video.addEventListener('pause', () => this.playButton.setAttribute('aria-pressed', 'false'));

          const mute = this.querySelector('.inp-tutorial__mute');
          mute.addEventListener('click', () => {
            this.video.muted = !this.video.muted;
            mute.setAttribute('aria-pressed', String(this.video.muted));
          });

          this.querySelector('.inp-tutorial__full').addEventListener('click', () => this.fullscreen());

          this.chapters.forEach(({ button, at }) =>
            button.addEventListener('click', () => {
              this.seek(at);
              this.play();
              if (window.matchMedia('(max-width: 989px)').matches) {
                this.media.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
            })
          );

          this.setupTimeline();

          // Stop when it scrolls out of view
          this.observer = new IntersectionObserver(
            ([entry]) => {
              if (!entry.isIntersecting && !document.fullscreenElement) this.video.pause();
            },
            { threshold: 0.2 }
          );
          this.observer.observe(this.media);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        // iPhone Safari loads nothing before play, so fall back to the length Shopify knows
        length() {
          return this.video.duration || Number(this.dataset.duration) || 0;
        }

        parseTime(value) {
          if (!value) return null;
          const parts = String(value).trim().split(':').map(Number);
          if (parts.some((part) => Number.isNaN(part))) return null;
          return parts.reduce((total, part) => total * 60 + part, 0);
        }

        format(seconds) {
          const s = Math.max(0, Math.floor(seconds || 0));
          return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
        }

        play() {
          const attempt = this.video.play();
          if (attempt && attempt.catch) attempt.catch(() => {});
        }

        ready() {
          return new Promise((resolve) => {
            if (this.video.readyState >= 1) return resolve();
            this.video.addEventListener('loadedmetadata', resolve, { once: true });
            this.video.load();
          });
        }

        async seek(seconds) {
          await this.ready();
          this.video.currentTime = Math.min(Math.max(seconds, 0), this.length() || seconds);
          this.paint();
        }

        fullscreen() {
          const target = this.media;
          if (document.fullscreenElement) return document.exitFullscreen();
          if (target.requestFullscreen) return target.requestFullscreen();
          // iPhone: only the video element itself can go full screen
          if (this.video.webkitEnterFullscreen) this.video.webkitEnterFullscreen();
        }

        paint() {
          const video = this.video;
          const length = this.length();
          const ratio = length ? video.currentTime / length : 0;
          this.scrub.style.setProperty('--progress', ratio * 100 + '%');
          this.scrub.setAttribute('aria-valuenow', Math.round(ratio * 100));
          this.scrub.setAttribute('aria-valuetext', this.format(video.currentTime));
          this.time.textContent =
            this.format(video.currentTime) + (length ? ' / ' + this.format(length) : '');

          let current = null;
          this.chapters.forEach((chapter) => {
            if (video.currentTime + 0.25 >= chapter.at) current = chapter;
          });
          if (current !== this.current) {
            this.current = current;
            this.chapters.forEach((chapter) => chapter.button.classList.toggle('is-current', chapter === current));
            this.now.textContent = current
              ? current.button.querySelector('.inp-tutorial__chapter-label').textContent
              : '';
          }
        }

        // Label over the timeline: the chapter at that point and its time, kept inside the bar
        showTip(event) {
          const tip = this.scrub.querySelector('.inp-tutorial__tip');
          const duration = this.length();
          if (!tip || !duration) return;
          const box = this.scrub.getBoundingClientRect();
          const x = Math.min(Math.max(event.clientX - box.left, 0), box.width);
          const at = (x / box.width) * duration;

          let chapter = null;
          this.chapters.forEach((item) => {
            if (at + 0.25 >= item.at) chapter = item;
          });
          tip.querySelector('.inp-tutorial__tip-label').textContent = chapter
            ? chapter.button.querySelector('.inp-tutorial__chapter-label').textContent
            : '';
          tip.querySelector('.inp-tutorial__tip-time').textContent = this.format(at);

          const half = tip.offsetWidth / 2;
          tip.style.setProperty('--tip-x', Math.min(Math.max(x, half), box.width - half) + 'px');
          clearTimeout(this.tipTimer);
          tip.classList.add('is-shown');
        }

        hideTip(delay = 0) {
          const tip = this.scrub.querySelector('.inp-tutorial__tip');
          if (!tip) return;
          clearTimeout(this.tipTimer);
          this.tipTimer = setTimeout(() => tip.classList.remove('is-shown'), delay);
        }

        placeTicks() {
          const duration = this.length();
          if (!duration) return;
          this.scrub.querySelectorAll('.inp-tutorial__tick').forEach((tick) => {
            const at = this.parseTime(tick.dataset.time);
            if (at !== null && at > 0) tick.style.setProperty('--at', (at / duration) * 100 + '%');
          });
        }

        setupTimeline() {
          const video = this.video;
          const scrub = this.scrub;

          const loop = () => {
            this.paint();
            if (!video.paused) this.frame = requestAnimationFrame(loop);
          };
          video.addEventListener('play', () => {
            cancelAnimationFrame(this.frame);
            loop();
          });
          video.addEventListener('pause', () => this.paint());
          video.addEventListener('loadedmetadata', () => {
            this.placeTicks();
            this.paint();
          });
          if (video.readyState >= 1 || this.length()) {
            this.placeTicks();
            this.paint();
          }

          const ratioAt = (event) => {
            const box = scrub.getBoundingClientRect();
            return (event.clientX - box.left) / box.width;
          };
          const seekRatio = async (ratio) => {
            await this.ready();
            this.seek(Math.min(Math.max(ratio, 0), 1) * this.length());
          };

          scrub.addEventListener('pointerdown', (event) => {
            event.preventDefault();
            try {
              scrub.setPointerCapture(event.pointerId);
            } catch (error) {
              // The pointer is already gone; the label and seek still work
            }
            scrub.classList.add('is-dragging');
            this.showTip(event);
            seekRatio(ratioAt(event));
          });
          scrub.addEventListener('pointermove', (event) => {
            this.showTip(event);
            if (scrub.classList.contains('is-dragging')) seekRatio(ratioAt(event));
          });
          scrub.addEventListener('pointerleave', () => {
            if (!scrub.classList.contains('is-dragging')) this.hideTip();
          });
          const stop = (event) => {
            scrub.classList.remove('is-dragging');
            // Touch has no hover: after a tap or drag the label stays a moment, then fades
            if (event.pointerType !== 'mouse') this.hideTip(1500);
          };
          scrub.addEventListener('pointerup', stop);
          scrub.addEventListener('pointercancel', stop);

          scrub.addEventListener('keydown', (event) => {
            const step = { ArrowRight: 5, ArrowUp: 5, ArrowLeft: -5, ArrowDown: -5 }[event.key];
            if (!step) return;
            event.preventDefault();
            this.seek(video.currentTime + step);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inp-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('inp-video-carousel')) {
    customElements.define(
      'inp-video-carousel',
      class InpVideoCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.inp-videos__track');
          if (!this.track) return;

          const section = this.closest('.inp-videos');
          this.arrows = section ? section.querySelectorAll('.inp-videos__arrow') : [];
          this.arrows.forEach((arrow) =>
            arrow.addEventListener('click', () => this.scrollByCard(Number(arrow.dataset.dir)))
          );

          this.onScroll = () => this.updateArrows();
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.updateArrows();

          this.querySelectorAll('.inp-videos__play').forEach((button) =>
            button.addEventListener('click', () => this.toggle(button))
          );

          // Sound is on when a video starts; the mute button keeps the choice for the next video
          this.muted = false;
          this.querySelectorAll('.inp-videos__mute').forEach((button) =>
            button.addEventListener('click', () => {
              this.muted = !this.muted;
              this.querySelectorAll('.inp-videos__video').forEach((video) => {
                if (!video.paused) video.muted = this.muted;
              });
              this.querySelectorAll('.inp-videos__mute').forEach((other) =>
                other.setAttribute('aria-pressed', String(this.muted))
              );
            })
          );

          this.querySelectorAll('.inp-videos__media').forEach((media) => this.setupTimeline(media));

          // Stop a playing video once it scrolls out of view
          this.observer = new IntersectionObserver(
            (entries) =>
              entries.forEach((entry) => {
                if (!entry.isIntersecting) this.pause(entry.target);
              }),
            { threshold: 0.25 }
          );
          this.querySelectorAll('.inp-videos__video').forEach((video) => this.observer.observe(video));
        }

        disconnectedCallback() {
          if (this.track) this.track.removeEventListener('scroll', this.onScroll);
          if (this.observer) this.observer.disconnect();
        }

        scrollByCard(dir) {
          const item = this.track.querySelector('.inp-videos__item');
          if (!item) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({ left: dir * (item.offsetWidth + gap) });
        }

        updateArrows() {
          if (!this.arrows.length) return;
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          this.arrows[0].disabled = this.track.scrollLeft <= 2;
          this.arrows[1].disabled = this.track.scrollLeft >= max;
        }

        toggle(button) {
          const video = button.parentElement.querySelector('video');
          if (!video) return;
          if (video.paused) {
            this.querySelectorAll('.inp-videos__video').forEach((other) => {
              if (other !== video) this.pause(other);
            });
            video.muted = this.muted;
            video.play();
            button.setAttribute('aria-pressed', 'true');
          } else {
            this.pause(video);
          }
        }

        setupTimeline(media) {
          const video = media.querySelector('video');
          const scrub = media.querySelector('.inp-videos__scrub');
          const time = media.querySelector('.inp-videos__time');
          if (!video || !scrub) return;

          const format = (seconds) => {
            const s = Math.max(0, Math.floor(seconds || 0));
            return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
          };

          const paint = () => {
            const ratio = video.duration ? video.currentTime / video.duration : 0;
            scrub.style.setProperty('--progress', ratio * 100 + '%');
            scrub.setAttribute('aria-valuenow', Math.round(ratio * 100));
            scrub.setAttribute('aria-valuetext', format(video.currentTime));
            if (time) time.textContent = format(video.currentTime) + (video.duration ? ' / ' + format(video.duration) : '');
          };

          // A smooth bar while playing, then one final paint on pause
          const loop = () => {
            paint();
            if (!video.paused) media.frame = requestAnimationFrame(loop);
          };
          video.addEventListener('play', () => {
            cancelAnimationFrame(media.frame);
            loop();
          });
          video.addEventListener('pause', paint);
          video.addEventListener('loadedmetadata', paint);

          const ready = () =>
            new Promise((resolve) => {
              if (video.readyState >= 1) return resolve();
              video.addEventListener('loadedmetadata', resolve, { once: true });
              video.preload = 'metadata';
              video.load();
            });

          const seekTo = async (ratio) => {
            await ready();
            video.currentTime = Math.min(Math.max(ratio, 0), 1) * video.duration;
            paint();
          };

          const ratioAt = (event) => {
            const box = scrub.getBoundingClientRect();
            return (event.clientX - box.left) / box.width;
          };

          scrub.addEventListener('pointerdown', (event) => {
            event.preventDefault();
            scrub.setPointerCapture(event.pointerId);
            scrub.classList.add('is-dragging');
            seekTo(ratioAt(event));
          });
          scrub.addEventListener('pointermove', (event) => {
            if (scrub.classList.contains('is-dragging')) seekTo(ratioAt(event));
          });
          const stop = () => scrub.classList.remove('is-dragging');
          scrub.addEventListener('pointerup', stop);
          scrub.addEventListener('pointercancel', stop);

          scrub.addEventListener('keydown', async (event) => {
            const step = { ArrowRight: 1, ArrowUp: 1, ArrowLeft: -1, ArrowDown: -1 }[event.key];
            if (!step) return;
            event.preventDefault();
            await ready();
            video.currentTime = Math.min(Math.max(video.currentTime + step, 0), video.duration);
            paint();
          });
        }

        pause(video) {
          if (!video.paused) video.pause();
          const button = video.parentElement.querySelector('.inp-videos__play');
          if (button) button.setAttribute('aria-pressed', 'false');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
